<template>
  <v-dialog
    :value="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @input="onDialogUpdate"
  >
    <v-card tile>
      <v-toolbar dark>
        <v-toolbar-title>{{ filename }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="onClose"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100% !important; overflow: auto">
        <v-img
          contain
          :src="url"
        ></v-img>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { slugify } from "@/utils/string"

export default {
  name: "DialogImgViewer",
  props: {
    item: {
      type: Object
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filename() {
      return slugify(this.item.name)
    },
    url() {
      return this.item.file_url
    }
  },
  methods: {
    onDialogUpdate(value) {
      if (!value) {
        this.onClose()
      }
    },
    onClose() {
      this.$emit("close", false)
    }
  }
}
</script>
